import precise from '../modules//precise';
import SVCFeeConstants from '../modules/SVCFees';

function SVCFees(options) {
  if (!options.vehicleClass) {
    throw new Error('vehicleClass is required to calculate SVCFees');
  }

  if (!options.numberOfMonths) {
    throw new Error('numberOfMonths is required to calculate SVCFees');
  }

  const vehicleClass = Number(options.vehicleClass);
  const months = Number(options.numberOfMonths);
  const Z = Number(options.weightlistValue || 0);

  const {
    RZfee,
    FVfee,
    ACfee,
    EMfee,
    LEfee,
    JJfee,
    TDfee,
    SSfee,
    AVfee,
    DDfee,
    SVCfee,
    AFfee,
    AFfee51,
    AFfee74,
    STfee,
    ADfee,
    MANUfee,
    PAfee,
    AFfee38,
  } = SVCFeeConstants;

  // This will either be 0.50 or 0
  const BFfee = options.BFfee;

  let FeeTot = 0;

  // vehicleClass 01, 91 (95?, 82?, 14?)  NO: STfee, ADfee, AFfee
  if ((vehicleClass === 1) && (months <= 13)) {
    FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + TDfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 1) && ((months === 14) || (months === 15))) {
    FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * TDfee) + (2 * SSfee) + AVfee + DDfee + AFfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 14) && (months <= 13)) {
    FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + TDfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 14) && ((months === 14) || (months === 15))) {
    FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * TDfee) + (2 * SSfee) + AVfee + DDfee + AFfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 31) && (months <= 13)) // 32,33
  {
    FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + TDfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 31) && ((months === 14) || (months === 15))) // 32,33
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * TDfee) + (2 * SSfee) + AVfee + DDfee + AFfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 82) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + TDfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 82) && ((months === 14) || (months === 15))) {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * TDfee) + (2 * SSfee) + AVfee + DDfee + AFfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 95) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + TDfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 95) && ((months === 14) || (months === 15))) {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * TDfee) + (2 * SSfee) + AVfee + DDfee + AFfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 91) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + TDfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 91) && ((months === 14) || (months === 15))) // then some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * TDfee) + (2 * SSfee) + AVfee + DDfee + AFfee + SVCfee + BFfee;
  }
  // vehicleClass 37, 85  NO: FVfee, ACfee, EMfee, LEfee, JJfee, STfee, ADfee, TDfee, SSfee, AVfee, AFfee
  if ((vehicleClass === 37) && (months <= 13)) {
      FeeTot = RZfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 37) && ((months === 14) || (months === 15))) {
      FeeTot = RZfee + DDfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 85) && (months <= 13)) {
      FeeTot = RZfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 85) && ((months === 14) || (months === 15))) {
      FeeTot = RZfee + DDfee + SVCfee + BFfee;
  }
  //  vehicleClass 41 (10,000GVW+), vehicleClass 102 (ag 10,000GVW+),  vehicleClass 39 (forestry 10,000GVW+) NO:  ADfee, TDfee, AFfee
  if ((vehicleClass === 410) && (months <= 13)) // (10,000GVW+) vehicleClass 41 Over
  {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + STfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 410) && ((months === 14) || (months === 15))) {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * STfee) + (2 * SSfee) + AVfee + DDfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 1020) && (months <= 13)) // (ag 10,000GVW+) clas 102 Over
  {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + STfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 1020) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * STfee) + (2 * SSfee) + AVfee + DDfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 390) && (months <= 13)) // (forestry 10,000GVW+) 39o = vehicleClass 39 Over
  {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + STfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 390) && ((months === 14) || (months === 15))) // then some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * STfee) + (2 * SSfee) + AVfee + DDfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 93) && (months <= 13)) // goat
  {
    FeeTot = RZfee+FVfee+ACfee+EMfee+LEfee+JJfee+SSfee+AVfee+DDfee+SVCfee+BFfee; // 1 to 13 months
  }
   if ((vehicleClass === 93) &&((months === 14) || (months === 15))) // goat then some fees charged twice
  {
    FeeTot = RZfee+FVfee+ACfee+(2*EMfee)+(2*LEfee)+(2*JJfee)+(2*SSfee)+AVfee+DDfee+SVCfee+BFfee;
  }
  //  vehicleClass 42,52,56,56,62,77,92, 94, 96, 102(under 10,000gvw), 41(under 10,000gvw)  NO: STfee, ADfee, TDfee, AFfee //
  if ((vehicleClass === 42) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 42) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * SSfee) + AVfee + DDfee + AFfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 52) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 52) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * SSfee) + AVfee + DDfee + AFfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 56) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 56) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * SSfee) + AVfee + DDfee + AFfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 62) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 62) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * SSfee) + AVfee + DDfee + AFfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 77) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 77) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * SSfee) + AVfee + DDfee + AFfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 92) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 92) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * SSfee) + AVfee + DDfee + AFfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 94) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 94) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * SSfee) + AVfee + DDfee + AFfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 96) && (months <= 13)) // 1 to 13 months
  {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + AVfee + DDfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 96) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * SSfee) + AVfee + DDfee + AFfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 102) && (months <= 13)) // vehicleClass 102 Under 10,000GVW
  {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 102) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * SSfee) + AVfee + DDfee + AFfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 41) && (months <= 13)) //  vehicleClass 41 Under 10,000GVW see vehicleClass 410 for over
  {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 41) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * SSfee) + AVfee + DDfee + AFfee + SVCfee + BFfee;
  }
  // vehicleClass 51,86,  NO: RZfee,LEfee,JJfee,STfee, ADFee, TDfee,SSfee,AVfee, AFfee=AFfee51
  // for those outside HS park
  if ((vehicleClass === 51) && (months <= 13)) {
      FeeTot = FVfee + ACfee + EMfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 51) && ((months === 14) || (months === 15))) // 14 & 15 months some fees charged twice
  {
      FeeTot = FVfee + ACfee + (2 * EMfee) + DDfee + SVCfee + BFfee;
  }
  // for those inside HS park
  if ((vehicleClass === 510) && (months <= 13)) {
      FeeTot = FVfee + ACfee + EMfee + DDfee + SVCfee + BFfee + AFfee51; // 1 to 13 months
  }
  if ((vehicleClass === 510) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = FVfee + ACfee + (2 * EMfee) + DDfee + SVCfee + BFfee + (2 * AFfee51);
  }
  // for those outside HS park
  if ((vehicleClass === 50) && (months <= 13)) {
      FeeTot = FVfee + ACfee + EMfee + DDfee + SVCfee + BFfee; // 1 to 13 months

  }
  if ((vehicleClass === 50) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = FVfee + ACfee + (2 * EMfee) + DDfee + SVCfee + BFfee;
  }
  // for those inside HS park
  if ((vehicleClass === 500) && (months <= 13)) {
      FeeTot = FVfee + ACfee + EMfee + DDfee + SVCfee + BFfee + AFfee51; // 1 to 13 months
  }
  if ((vehicleClass === 500) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = FVfee + ACfee + (2 * EMfee) + DDfee + SVCfee + BFfee + (2 * AFfee51);
  }
  // vehicleClass 76,78  NO: LEfee,JJfee,STfee, ADFee, TDfee, AFfee=AFfee51   //
  if ((vehicleClass === 76) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 76) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * SSfee) + AVfee + DDfee + SVCfee + BFfee;
  }
  // for those inside HS park
  if ((vehicleClass === 760) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + AVfee + DDfee + SVCfee + BFfee + AFfee51; // 1 to 13 months
  }
  if ((vehicleClass === 760) && ((months === 14) || (months === 15))) // 14 & 15 months some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * SSfee) + AVfee + DDfee + SVCfee + BFfee + (2 * AFfee51);
  }
  // for those outside HS park
  if ((vehicleClass === 78) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 78) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * SSfee) + AVfee + DDfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 86) && (months <= 15)) {
      FeeTot = FVfee + ACfee + EMfee + SVCfee + BFfee + PAfee + MANUfee; // 1 to 15 months
  }
  //  vehicleClass 65,80,69  NO: STfee, TDfee, AFfee   //
  if ((vehicleClass === 65) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + ADfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 65) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * ADfee) + (2 * SSfee) + AVfee + DDfee + AFfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 80) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + ADfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 80) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * ADfee) + (2 * SSfee) + AVfee + DDfee + AFfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 69) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + ADfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 69) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * ADfee) + (2 * SSfee) + AVfee + DDfee + AFfee + SVCfee + BFfee;
  }
  // vehicleClass 70,71,74,  NO: STfee, ADfee, TDfee, AFfee
  if ((vehicleClass === 70) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 70) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * SSfee) + AVfee + DDfee + SVCfee + BFfee;
  }
  // vehicleClass 71,74,  NO: STfee, ADfee, TDfee, AFfee = AFfee74
  if ((vehicleClass === 71) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + AVfee + DDfee + AFfee74 + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 71) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * SSfee) + AVfee + (2 * AFfee74) + DDfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 74) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + AVfee + DDfee + AFfee74 + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 74) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * SSfee) + AVfee + (2 * AFfee74) + DDfee + SVCfee + BFfee;
  }
  //  103, 97   NO: STfee, ADfee, TDfee, AVfee, DDfee, AFfee //
  if ((vehicleClass === 103) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 103) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * SSfee) + AFfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 97) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 97) && ((months === 14) || (months === 15))) // 14&15 months some fees charged twice
  {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * SSfee) + AFfee + SVCfee + BFfee;
  }
  // For HIre vehicleClass 09, // no TDfee, AFfee
  if ((vehicleClass === 9) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 9) && ((months === 14) || (months === 15))) {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * SSfee) + AVfee + DDfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 54) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 54) && ((months === 14) || (months === 15))) {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * SSfee) + AVfee + DDfee + SVCfee + BFfee;
  }
  // vehicleClass 53 and 36 buses  and 6 month buses(set as vehicleClass 360 for calculation)
  if ((vehicleClass === 53) && (months <= 13)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 53) && ((months === 14) || (months === 15))) {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * SSfee) + AVfee + DDfee + SVCfee + BFfee;
  }
  if ((vehicleClass === 36) && (months <= 13) && (Z >= 10001)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + STfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  }
  if ((vehicleClass === 36) && ((months === 14) || (months === 15)) && (Z >= 10001)) {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * STfee) + (2 * SSfee) + AVfee + DDfee + SVCfee + BFfee;
  } // No STfee
  if ((vehicleClass === 36) && (months <= 13) && (Z <= 10000)) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + AVfee + DDfee + SVCfee + BFfee; // 1 to 13 months
  } // No STfee
  if ((vehicleClass === 36) && ((months === 14) || (months === 15)) && (Z <= 10000)) {
      FeeTot = RZfee + FVfee + ACfee + (2 * EMfee) + (2 * LEfee) + (2 * JJfee) + (2 * SSfee) + AVfee + DDfee + SVCfee + BFfee;
  }
  // NOTE: John used to force the 6-month rule when calculating vehicle class 360
  // He wouldn't even bother calculating unless the months were forced to be 6:
  // if ((vehicleClass === 360) && (months === 6)) {
  if (vehicleClass === 360) {
      FeeTot = RZfee + FVfee + ACfee + EMfee + LEfee + JJfee + SSfee + AVfee + DDfee + SVCfee + BFfee + AFfee38; // 1 to 13 months
  }
  return precise(FeeTot);
}

export default SVCFees;



// WEBPACK FOOTER //
// ./src/modules/getSVCFee.js